import { useMemo } from 'react';

const { useTranslation } = require('next-i18next');

const useLocationsCMSData = () => {
  const { t } = useTranslation('');

  const data = useMemo(
    () => ({
      data: {
        LocationsPage: {
          pageTitle: t('locationsV2_page:page_title'),
          makeReservationBtn: t('locationsV2_page:make_reservation'),
          showMap: t('locationsV2_page:show_map'),
          apply: t('locationsV2_page:apply'),
          filter: t('locationsV2_page:filter'),
          searchLocationName: t('locationsV2_page:search_by_location'),
          filterBy: t('locationsV2_page:filter_by'),
          clubEaglerider: t('locationsV2_page:club_eaglerider'),
          locationParticipating: t('locationsV2_page:location_participating'),
          internationalLocations: t('locationsV2_page:international_locations'),
        },
        FloatingLocationInfoComponent: {
          bookNow: t('common_floating_location_info:book_now'),
          locationDetails: t('common_floating_location_info:location_details'),
          clubEaglerider: t('common_floating_location_info:club_eaglerider'),
        },
        RadioFilterComponent: {
          locations: t('common_radio_filter_v2:locations'),
          allLocations: t('common_radio_filter_v2:all_locations'),
          us: t('common_radio_filter_v2:us'),
          international: t('common_radio_filter_v2:international'),
          clubEaglerider: t('common_radio_filter_v2:club_eaglerider'),
          locationParticipating: t(
            'common_radio_filter_v2:club_eaglerider_location',
          ),
        },
      },
    }),
    [],
  );

  return data;
};

export { useLocationsCMSData };
